import _extends from "@babel/runtime-corejs2/helpers/extends";
import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import classNames from 'classnames';
import mergeRefs from '../helpers/mergeRefs';
import { ContextConsumer } from './Context';
import NavItem from './NavItem';
import NavTooltip from './NavTooltip';
import SearchEntity from './SearchEntity';
import SearchHeader from './SearchHeader';
import SearchResults from './SearchResults';
import SearchSection from './SearchSection';
import SearchSelect from './SearchSelect';
import SearchInput from './SearchInput';
import SearchResult from './SearchResult';
var KEYCODES = {
  ESCAPE: 27,
  FORWARD_SLASH: 191,
  S: 83
};

var NavSearch = /*#__PURE__*/function (_React$Component) {
  _inherits(NavSearch, _React$Component);

  var _super = _createSuper(NavSearch);

  function NavSearch(props) {
    var _this;

    _classCallCheck(this, NavSearch);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "bodyClickListener", function (event) {
      if (_this.props.searchActive && !_this.props.searchResultsRef.current.contains(event.target) && !_this.ref.current.contains(event.target)) {
        _this.hideSearch();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "defaultCategoryKeyBinding", function (e) {
      if (!_this.props.categories || !e.altKey) return;

      var category = _this.props.categories.find(function (category) {
        return category.shortcut && category.shortcut.keycode === e.which;
      });

      return category;
    });

    _defineProperty(_assertThisInitialized(_this), "defaultSearchKeyBinding", function (e) {
      // forward slash OR s
      return !e.shiftKey && (e.which === KEYCODES.FORWARD_SLASH || e.which === KEYCODES.S);
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      var _this$props = _this.props,
          _this$props$categoryK = _this$props.categoryKeyBinding,
          categoryKeyBinding = _this$props$categoryK === void 0 ? _this.defaultCategoryKeyBinding : _this$props$categoryK,
          searchActive = _this$props.searchActive,
          _this$props$searchKey = _this$props.searchKeyBinding,
          searchKeyBinding = _this$props$searchKey === void 0 ? _this.defaultSearchKeyBinding : _this$props$searchKey,
          setSearchCategory = _this$props.setSearchCategory;

      if (searchActive && e.which === KEYCODES.ESCAPE) {
        _this.hideSearch();
      } else {
        var target = e.target;
        var input = target.tagName.toUpperCase() === 'INPUT';
        var textarea = target.tagName.toUpperCase() === 'TEXTAREA';

        if (searchActive) {
          var category = categoryKeyBinding(e);
          var otherInput = input && target !== _this.inputRef.current;

          if (category && !otherInput && !textarea) {
            e.preventDefault();
            setSearchCategory(category.name);
          }
        } else if (!input && !textarea && searchKeyBinding(e)) {
          e.preventDefault();

          _this.showSearch();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseOver", function () {
      _this.setState({
        hover: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseOut", function () {
      _this.setState({
        hover: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "showSearch", function () {
      _this.setState({
        hover: false
      });

      _this.props.setSearchActive(true);
    });

    _defineProperty(_assertThisInitialized(_this), "hideSearch", function () {
      _this.props.searchResultsRef.current.scrollTop = 0;

      _this.props.resetSearch();
    });

    _this.state = {
      hover: false
    };
    _this.inputRef = /*#__PURE__*/React.createRef();

    var _mergeRefs = mergeRefs(props.forwardedRef),
        ref = _mergeRefs.ref,
        setRef = _mergeRefs.setRef;

    _this.ref = ref;
    _this.setRef = setRef;
    return _this;
  }

  _createClass(NavSearch, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.addEventListener('click', this.bodyClickListener, true);
      document.body.addEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.removeEventListener('click', this.bodyClickListener, true);
      document.body.removeEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: "render",
    value: function render() {
      var hover = this.state.hover;
      var _this$props2 = this.props,
          categories = _this$props2.categories,
          children = _this$props2.children,
          inputProps = _this$props2.inputProps,
          inverted = _this$props2.inverted,
          placeholder = _this$props2.placeholder,
          searchActive = _this$props2.searchActive,
          searchPhrase = _this$props2.searchPhrase,
          onChangeSearch = _this$props2.onChangeSearch,
          onChangeSearchCategory = _this$props2.onChangeSearchCategory;
      return /*#__PURE__*/React.createElement("div", {
        className: "cloud-ui-search-wrapper",
        ref: this.props.innerRef
      }, searchActive && /*#__PURE__*/React.createElement("div", {
        className: classNames('cloud-ui-search-bar', {
          'with-results': searchPhrase
        }),
        ref: this.setRef
      }, categories && /*#__PURE__*/React.createElement(SearchSelect, {
        categories: categories,
        onChangeSearchCategory: onChangeSearchCategory
      }), searchActive && /*#__PURE__*/React.createElement(SearchInput, {
        inputProps: inputProps,
        onChangeSearch: onChangeSearch,
        placeholder: placeholder,
        ref: this.inputRef
      }), /*#__PURE__*/React.createElement(NavItem, {
        className: "cloud-ui-search-close",
        icon: "close",
        onClick: this.hideSearch
      })), !searchActive && /*#__PURE__*/React.createElement(NavTooltip, {
        className: "cloud-ui-search",
        trigger: /*#__PURE__*/React.createElement(NavItem, {
          icon: "search",
          onMouseOver: this.onMouseOver,
          onMouseOut: this.onMouseOut,
          onFocus: this.onMouseOver,
          onBlur: this.onMouseOut,
          onClick: this.showSearch
        }),
        open: hover,
        content: "Search",
        inverted: inverted
      }), children);
    }
  }]);

  return NavSearch;
}(React.Component);

_defineProperty(NavSearch, "Entity", SearchEntity);

_defineProperty(NavSearch, "Header", SearchHeader);

_defineProperty(NavSearch, "Results", SearchResults);

_defineProperty(NavSearch, "Result", SearchResult);

_defineProperty(NavSearch, "Input", SearchInput);

_defineProperty(NavSearch, "Section", SearchSection);

_defineProperty(NavSearch, "Select", SearchSelect);

var NavSearchWrapper = function NavSearchWrapper(props) {
  return /*#__PURE__*/React.createElement(ContextConsumer, null, function (_ref) {
    var searchActive = _ref.searchActive,
        searchPhrase = _ref.searchPhrase,
        setSearchActive = _ref.setSearchActive,
        setSearchCategory = _ref.setSearchCategory,
        resetSearch = _ref.resetSearch,
        searchResultsRef = _ref.searchResultsRef;
    return /*#__PURE__*/React.createElement(NavSearch, _extends({}, props, {
      searchActive: searchActive,
      searchPhrase: searchPhrase,
      setSearchActive: setSearchActive,
      setSearchCategory: setSearchCategory,
      resetSearch: resetSearch,
      searchResultsRef: searchResultsRef
    }));
  });
};

NavSearchWrapper.Entity = NavSearch.Entity;
NavSearchWrapper.Header = NavSearch.Header;
NavSearchWrapper.Results = NavSearch.Results;
NavSearchWrapper.Result = NavSearch.Result;
NavSearchWrapper.Section = NavSearch.Section;
export default NavSearchWrapper;